// Утилита для форматирования текста фильтров
export const formatFilterText = (text) => {
  if (!text || typeof text !== 'string') {
    return text;
  }

  const lowerText = text.toLowerCase().trim();

  // Преобразования для множественного числа
  if (lowerText === 'пост') {
    return 'посты';
  }

  if (lowerText === 'статья') {
    return 'статьи';
  }

  // Возвращаем оригинальный текст, если преобразование не нужно
  return text;
};

export default formatFilterText;
